import type { Toast, ToastState } from '@trustoo/components/ui/toaster/types/toastTypes'

export type ToastAction =
    | { type: 'add'; toast: Toast; maxToasts?: number }
    | { type: 'delete'; id: string }
    | { type: 'deleteAll' }

export const toastReducer = (state: ToastState, action: ToastAction): ToastState => {
    switch (action.type) {
        case 'add': {
            if (action.maxToasts === undefined) {
                return { ...state, [action.toast.id]: action.toast }
            }
            const entries = Object.values(state).filter(({ id }) => id !== action.toast.id)
            entries.push(action.toast)
            const retained = entries.slice(-action.maxToasts)
            return Object.fromEntries(retained.map((toast) => [toast.id, toast]))
        }
        case 'delete': {
            const next = { ...state }
            delete next[action.id]
            return next
        }
        case 'deleteAll':
            return {}
        default:
            return state
    }
}
